<template>
  <div class="login-wrapper">
    <div class="login-box" style="margin: 0 auto">
      <h3 class="login-box__title">ŞİFRE YENİLE</h3>
      <v-input placeholder="E-MAİL ADRESİNİZ" v-model="email" />
      <label for="password" v-if="falseEmail" class="myValidationText">Geçersiz e-posta formatı!</label>
      <label for="password" v-if="emptyEmail" class="myValidationText">Bu kısım boş geçilemez!</label>
      <v-input placeholder="ŞİFRENİZ" v-model="password1"/>
      <label for="password" v-if="emptyPassword1" class="myValidationText">Bu kısım boş geçilemez!</label>
      <v-input placeholder="ŞİFRENİZ TEKRAR" v-model="password2" />
      <label for="password" v-if="emptyPassword2" class="myValidationText">Bu kısım boş geçilemez!</label>
 
      <v-button
        to="/"
        class="green fw shadow-none login-box__submit"
        title="ŞİFREYİ YENİLE"
        @click.native="renewPassword"/>
  </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Şifremi Unuttum',
      link: [
        { rel: 'canonical', href: window.location.origin + '/sifremi-unuttum/' }
      ]
    }
  },  
  data: function () {
    return {
      falseEmail: false,
      emptyEmail: false,
      emptyPassword1: false,
      emptyPassword2: false,
      email: '',
      emailBlured: false,
      password1: null,
      password2: null,
      valid: false,
      submitted: false
    }
  },

  methods: {
    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },    
    validate: function () {
      this.emailBlured = true
      if (this.validEmail(this.email)) {
        this.valid = true
      }
    },

    validEmail: function (email) {
      var re = /(.+)@(.+){2,}\.(.+){2,}/
      return re.test(email.toLowerCase())
    },
    renewPassword() {
      this.falseEmail = false
      this.emptyPassword = false
      this.emptyEmail = false
      const verifiedMail = this.validateEmail(this.email)
      if(!this.password1) {
      this.emptyPassword1 = true
      }
      if(!this.password2) {
      this.emptyPassword2 = true
      }      
      if(!this.email) {
        this.emptyEmail = true
      } else if(this.email && !verifiedMail) {
        this.falseEmail = true
      }
      if(!this.email) {
        this.emptyEmail = true
      }
      
      if(verifiedMail && this.password1 && this.password2)  {  
      axios.put(`/user/update/session`, {
      password: this.password2,
      password_confirmation: this.password3
    })
    .then(response => {
            if (response.status === 200 || response.status === 201) {
              self.showSuccessMessage = true
            }
        })
        .catch(e => {
          this.errors.push(e)
        })       

    }
  }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/login";

</style>
